export const srr = {
  "srr.target.get": "srr.target.get",
  "srr.target.set": "srr.target.set",
  "srr.gibdd.get": "srr.gibdd.get",
  "srr.gibdd.set": "srr.gibdd.set",
  "srr.family.get": "srr.family.get",
  "srr.returnTo.get": "srr.returnTo.get",
  "srr.other.get": "srr.other.get",
  "srr.ssr35.get": "srr.ssr35.get",
  //"srr.uvin.get": "srr.uvin.get", // TODO: при продолжении разработки раскомментировать, встречается в файлах Router, index(Layout), options(SRR)
  //"srr.ns.get": "srr.ns.get",     // TODO: при продолжении разработки раскомментировать, встречается в файлах Router, index(Layout), options(SRR)
  //"srr.ns.set": "srr.ns.set",     // TODO: при продолжении разработки раскомментировать, не встречается нигде
  "srr.carArrivals.get": "srr.carArrivals.get",
  "srr.oneCSales.get": "srr.oneCSales.get",
} as const;
